module.exports = __webpack_public_path__ + "media/scholarships/icon-outlookcom-4dbb0dfb.svg";